import React, { useEffect, useState } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import PasswordLiveCheck from './component/PasswordLiveCheck';
import { PasswordValidationItem } from './component/CheckLine';

type PasswordFieldProps = {
  label: string;
  controllerInitialState: UseControllerProps<any>;
  validationConfig?: Array<PasswordValidationItem>;
  showPassword?: boolean;
  onPressShowPassword?: (show: boolean) => void;
};

export const PasswordField: React.FC<PasswordFieldProps> = ({
  controllerInitialState,
  label,
  validationConfig,
  showPassword,
  onPressShowPassword,
}) => {
  const [displayPassword, setDisplayPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (showPassword !== undefined) {
      setDisplayPassword(showPassword);
    }
  }, [showPassword]);

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController(controllerInitialState);

  const handleDisplayPassword = () => {
    setDisplayPassword(!displayPassword);
    if (onPressShowPassword) {
      onPressShowPassword(!displayPassword);
    }
  };

  return (
    <>
      <TextField
        label={label}
        fullWidth={true}
        variant={'outlined'}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        type={displayPassword ? 'text' : 'password'}
        error={!!error}
        helperText={error ? error.message : null}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleDisplayPassword}>
                {displayPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {validationConfig && <PasswordLiveCheck show={isFocused} password={value as string} config={validationConfig} />}
    </>
  );
};
